module.exports = __webpack_public_path__ + "img/pl.dab68e30.svg";